import React, { Component } from 'react';
import { Big3Common, bootstrap } from "../../../js/IncludeManager";
import { Alert, Timmer } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:비밀번호 찾기
 * 세부설명:
*/
export class FindPwd extends Component {
    static displayName = FindPwd.name;

    constructor(props) {
        super(props);
        this.state = {
            FindModel: {
                Login_Id: "",
                User_Phone: "",
                Certifi_No: "",
            },
            LoginIdModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            PhoneModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            CertifiModel: { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false },
            Title: "인증번호가 일치하지 않습니다.",
            Certifi_Css: "item_hide",
            SeqNo: "",
            isCertifiClick: false,    //인증버튼 재클릭 금지
            BtnFindOk: false          //버튼활성화  
        };
        this.refTimmer = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleCertifiSend = this.handleCertifiSend.bind(this);
        this.handleCertifiValid = this.handleCertifiValid.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleAlertClick = this.handleAlertClick.bind(this);
    }
    jsonAttr = { "Hide": "item_hide", "Msg": "", "ChkCss": "item_hide", "CheckOk": false }
    //검증속성 기본값
    AttrDefaultSet() {
        this.jsonAttr.Hide = "item_hide"; //input_txt,item_hide
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "item_hide"; //false,check,item_hide
    }
    //검증속성 Good
    AttrCheckOkSet() {
        this.jsonAttr.Hide = "input_txt";
        this.jsonAttr.Msg = "";
        this.jsonAttr.CheckOk = true;
        this.jsonAttr.ChkCss = "check";
    }
    //검증속성 No Good
    AttrErrorSet(Msg) {
        this.jsonAttr.Hide = "input_txt";
        this.jsonAttr.Msg = Msg;
        this.jsonAttr.CheckOk = false;
        this.jsonAttr.ChkCss = "false";
    }
    //초기화
    componentDidMount() {
    }
    handleChange(event) {
        let tagId = event.target.id;
        let value = event.target.value.trim();
        if (tagId === "User_Phone" || tagId === "Certifi_No") {
            //핸드폰,인증번호 숫자만 입력 되게 처리
            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
        }
        Big3Common.ValueCahage_StateUpdate({ this: this, event: event, modelName: "FindModel" });
        event.preventDefault();
    }
    async handleBlur(event) {
        let tagId = event.target.id;
        let ModelName = this.GetModelName(tagId);
        let ModelValue = this.state.FindModel[tagId];
        let ModelLen = ModelValue.length;
        if (ModelLen === 0) {
            this.AttrDefaultSet();
        }

        if (tagId === "Login_Id" && ModelLen > 0) {
            this.AttrCheckOkSet();
        }
        else if (tagId === "User_Phone" && ModelLen > 0) {
            let isCheck = Big3Common.Util.HandPhoneCheck(ModelValue);
            if (!isCheck) {
                this.AttrErrorSet("핸드폰번호 형식이 잘못 되었습니다.");
            }
            else {
                let hpFormat = Big3Common.Util.HandPhoneFormat(ModelValue);
                Big3Common.updateStateModel({ this: this, modelName: "FindModel", updateModel: { [tagId]: hpFormat } });
                this.AttrCheckOkSet();
                this.jsonAttr.Hide = "input_txt";
                this.jsonAttr.Msg = "인증번호 전송 버튼을 클릭하세요.";
            }
        }

        if (ModelName === "") return false;

        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });
        event.preventDefault();
    }
    //비밀번호 찾기 
    async handleSearch_Click(event) {
        if (!this.state.BtnFindOk) return false;

        try {
            let Data = await Big3Common.Post("api/Account/LoginMgr/NewPassword",
                {
                    "user_phone": this.state.FindModel.User_Phone,
                    "login_id": this.state.FindModel.Login_Id,
                    "seqno": this.state.SeqNo,
                    "certifi_no": this.state.FindModel.Certifi_No
                });

            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.ModalAlert(bootstrap, 'PwdFindOk');
            }
            else {
                this.setState({ Title: Data.message });
                Big3Common.ModalAlert(bootstrap, 'PwdAlert');
            }
        }
        catch (e) {
            console.log("handleSearch_Click: ", e);
        }
        event.preventDefault();
    }
    //비밀번호 발송
    async handleAlertClick(modalID) {

        if (modalID === "PwdFindOk") {
            this.props.RenderComponent('SignIn');
        }
        return false;
    }
    //X버튼 클릭시 초기화
    handleClear_Click(tagId) {
        let ModelName = this.GetModelName(tagId);
        //value 값 초기화
        Big3Common.updateStateModel({ this: this, modelName: "FindModel", updateModel: { [tagId]: "" } })
        this.AttrDefaultSet();
        //속성값 초기화
        Big3Common.updateStateModel({ this: this, modelName: ModelName, updateModel: this.jsonAttr });
        return false;
    }
    //인증번호 전송
    async handleCertifiSend(event) {
        if (!this.state.LoginIdModel.CheckOk) {
            this.AttrErrorSet("아이디를 확인하여 주세요.");
            Big3Common.updateStateModel({ this: this, modelName: "LoginIdModel", updateModel: this.jsonAttr });
            return false;
        }
        else if (!this.state.PhoneModel.CheckOk) {
            this.AttrErrorSet("핸드폰 번호를 확인하여 주세요.");
            Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });
            return false;
        }
        else {
            if (this.state.isCertifiClick) {
                return false;
            }
            this.setState({ "isCertifiClick": true });
            try {
                let Data = await Big3Common.Post("api/Account/LoginMgr/PWdCertifino", { "user_phone": this.state.FindModel.User_Phone, "login_id": this.state.FindModel.Login_Id });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let seqno = Data.objectData;
                    this.setState({ "SeqNo": seqno });
                    this.AttrCheckOkSet();
                    this.jsonAttr.Msg = Data.message;
                    Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });

                    //재전송 클릭 시 입력시간 초과 메세지 클리어
                    this.AttrDefaultSet();
                    Big3Common.updateStateModel({ this: this, modelName: "CertifiModel", updateModel: this.jsonAttr });

                    //인증번호 전송 후 타이머 쇼
                    this.setState({ Certifi_Css: "input_line" });
                    this.refTimmer.current.Play();

                }
                else {

                    this.setState({ "isCertifiClick": false, Title: Data.message });
                    this.AttrErrorSet();
                    this.jsonAttr.Msg = Data.message;
                    Big3Common.updateStateModel({ this: this, modelName: "PhoneModel", updateModel: this.jsonAttr });
                    Big3Common.ModalAlert(bootstrap, 'PwdAlert');
                }
            }
            catch (e) {
                console.log("handleCertifiSend: ", e);
            }
        }

        event.preventDefault();
    }
    //인증번호 확인
    async handleCertifiValid(event) {
        if (this.state.CertifiNumberOk === true) {
            //이미 인증했음.
            return false;
        }
        if (this.refTimmer.current.isTimeOut()) {
            this.AttrErrorSet("입력시간이 초과 되었습니다.");
            this.setState({ "SeqNo": "", "isCertifiClick": false });
        }
        else if (this.state.FindModel.Certifi_No.trim().length === 0) {
            this.AttrErrorSet("인증번호를 입력하여 주세요.");
        }
        else {

            try {
                let Data = await Big3Common.Post("api/Common/Common/CertifinoVerification", { "seqno": this.state.SeqNo, "certifi_no": this.state.FindModel.Certifi_No });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    //인증성공
                    this.setState({ "CertifiNumberOk": true, BtnFindOk: true });
                    this.refTimmer.current.Stop();
                    this.AttrCheckOkSet();
                    this.jsonAttr.Msg = Data.message;
                }
                else if (Data.codeName === Big3Common.ResultCode.Warning) {
                    //인증번호 불일치
                    this.AttrErrorSet(Data.message);
                    this.setState({ Title: Data.message });
                    Big3Common.ModalAlert(bootstrap, 'PwdAlert');

                }
                else {
                    //오류
                    this.AttrErrorSet(Data.message);
                    this.setState({ "SeqNo": "", "isCertifiClick": false });
                }
            }
            catch (e) {
                console.log("handleCertifiValid :", e);
            }
        }
        Big3Common.updateStateModel({ this: this, modelName: "CertifiModel", updateModel: this.jsonAttr });
        event.preventDefault();
    }

    //모델이름 반환
    GetModelName(tagId) {
        let ModelName = "";
        if (tagId === "Login_Id") {
            ModelName = "LoginIdModel";
        }
        else if (tagId === "User_Phone") {
            ModelName = "PhoneModel";
        }
        else if (tagId === "Certifi_No") {
            ModelName = "CertifiModel";
        }
        return ModelName;
    }
    buttonRender() {
        return (
            <button type="button" className={this.state.BtnFindOk === true ? "btn_v btn_v1" : "btn_v btn_inactive"} onClick={this.handleSearch_Click} >비밀번호 찾기</button>
        );
    }
    render() {
        let buttonRender = this.buttonRender();
        return (
            <div>
                <div className="input_box">
                    <div className="input_line">
                        <label>아이디</label>
                        <input type="text"
                            className="form-control"
                            id="Login_Id"
                            value={this.state.FindModel.Login_Id}
                            onChange={this.handleChange}
                            maxLength="20"
                            placeholder="아이디를 입력하세요"
                            onBlur={this.handleBlur}
                        />
                        <div className={this.state.LoginIdModel.ChkCss} onClick={() => this.handleClear_Click('Login_Id')} ></div>
                        <div className={this.state.LoginIdModel.Hide} >{this.state.LoginIdModel.Msg}</div>
                    </div>
                    <div className="input_line">
                        <label>휴대폰번호</label>
                        <div className="nc_box">
                            <input type="tel"
                                className="form-control cn_input"
                                id="User_Phone"
                                value={this.state.FindModel.User_Phone}
                                onChange={this.handleChange}
                                maxLength="13"
                                placeholder="휴대폰번호를 입력하세요. (-는 제외)"
                                onBlur={this.handleBlur}
                            />
                            <button type="button" className={this.state.SeqNo === "" ? "cn_button btn_v1" : "cn_button btn_inactive"} onClick={this.handleCertifiSend} >인증번호 전송</button>
                        </div>
                        <div className={this.state.PhoneModel.Hide}>{this.state.PhoneModel.Msg}</div>
                        <div className={this.state.PhoneModel.ChkCss} style={{ marginRight: 100 }} onClick={() => this.handleClear_Click('User_Phone')}  ></div>
                    </div>
                    <div className={this.state.Certifi_Css}  >
                        <label>인증번호</label>
                        <div className="nc_box">
                            <input type="text"
                                id="Certifi_No"
                                className="form-control cn_input"
                                maxLength="6"
                                value={this.state.FindModel.Certifi_No}
                                onChange={this.handleChange}
                            />
                            <div className="time_1">
                                <Timmer Minutes="5"
                                    Seconds="0"
                                    ref={this.refTimmer}
                                />
                            </div>
                            <button type="button" className={this.state.CertifiNumberOk === true ? "cn_button btn_inactive" : "cn_button btn_v1"} onClick={this.handleCertifiValid}>인증 확인</button>
                        </div>
                        <div className={this.state.CertifiModel.Hide}>{this.state.CertifiModel.Msg}</div>
                        <div className={this.state.CertifiModel.ChkCss} style={{ marginRight: 170 }} onClick={() => this.handleClear_Click('Certifi_No')}  ></div>
                    </div>
                </div>
                {/*<!--비밀번호 찾기 버튼 비활성-->*/}
                <div className="button_line bottom_line">
                    {buttonRender}
                </div>
                <Alert
                    id="PwdAlert"
                    title={this.state.Title}
                />
                <Alert
                    id="PwdFindOk"
                    title="임시 비밀번호가 전송되었습니다."
                    content="로그인 후 반드시 비밀번호를 변경해주세요."
                    AlertClick={this.handleAlertClick}
                />
            </div>
        );
    }
}
